import { html as e, when as i, ref as s } from "@microsoft/fast-element";
const l = (o) => {
  const a = e.partial(o.prefix);
  return e`
    ${i(
    (t) => t.total > 0,
    e`
        <div class="control" part="control">
          <${a}-button
            variant="ghost"
            @click="${(t) => t.previousPage()}"
            ?disabled="${(t) => t.page <= 1 || t.disabled}"
            size="${(t) => t.size}"
          >
            <${a}-icon slot="start" name="chevron-left" />
          </${a}-button>
          <div class="pages" part="pages">
            <${a}-input
              type="number"
              autocomplete="off"
              ?required="${(t) => !(t.page == 1 && t.total == 1)}"
              min="1"
              max="${(t) => t.total}"
              :value="${(t) => t.page}"
              @change="${(t) => t.setPage()}"
              ?disabled="${(t) => t.disabled}"
              ${s("_input")}
            ></${a}-input>
            <span class="of" part="of"> ${(t) => t.i18n.of} </span>
            <span class="total" part="total"> ${(t) => t.total} </span>
          </div>
          <${a}-button
            variant="ghost"
            @click="${(t) => t.nextPage()}"
            ?disabled="${(t) => t.page >= t.total || t.disabled}"
            size="${(t) => t.size}"
          >
            <${a}-icon slot="start" name="chevron-right" />
          </${a}-button>
        </div>
      `
  )}
  `;
};
export {
  l as paginationTemplate
};
